import request from '@/utils/request'

// const Url = 'http://192.168.2.3:8080/dms/soft'

export function getDms() {
  return request({
    url: '/dms/wdms/soft',
    method: 'get'
  })
}

export function postDms(data) {
  return request({
    url: '/dms/wdms/soft',
    method: 'post',
    data
  })
}

export function delDms(params) {
  return request({
    url: '/dms/wdms/soft',
    method: 'delete',
    params
  })
}

export function getIplugin() {
  return request({
    url: '/dms/iot/soft',
    method: 'get'
  })
}

export function postIplugin(data) {
  return request({
    url: '/dms/iot/soft',
    method: 'post',
    data
  })
}

export function delIplugin(params) {
  return request({
    url: '/dms/iot/soft',
    method: 'delete',
    params
  })
}
